import React from 'react';
import PropTypes from 'prop-types';

export default class MenuItem extends React.Component {

	static propTypes = {
		path: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		exact: PropTypes.bool,
		isItem: PropTypes.bool,
	};
	
	static defaultProps = {
		exact: false,
		isItem: true,
	};
	
	render() {
		return null;
	}
	
}
